import { render, staticRenderFns } from "./CourseSection.vue?vue&type=template&id=81aeb752&"
import script from "./CourseSection.vue?vue&type=script&lang=js&"
export * from "./CourseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CourseSection.vue"
export default component.exports